import React, { useEffect, useState, forwardRef } from "react";
import DaumPostcode from "react-daum-postcode";
import {
  Button,
  Dialog,
  Slide,
  AppBar,
  Box,
  Link,
  Divider,
  TextField,
} from "@mui/material";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function RegisterFormAddr(props) {
  const [open, setOpen] = useState(false);
  const [addr1, setAddr1] = useState("");
  const [addr2, setAddr2] = useState("");
  const {set1, set2} = props;

  const handleComplete = (data) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }
    // console.log(fullAddress); // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
    setAddr1(fullAddress);    
    setOpen(false);
    set1(fullAddress);
  };

  const onClose = () => {
    //
  };

  return (
    <Box
      sx={{
        marginTop: '10px',
      }}>

      <Dialog
        fullScreen
        open={open}
        TransitionComponent={Transition}
        onClose={onClose}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Box onClick={() => setOpen(false)}>
            <img src="/img/back_button_black.png" />
          </Box>
          <Box sx={{mt:3}}></Box>
          {/* <Box
            sx={{
              margin: "25px 0 0 10px",
              fontSize: "22px",
            }}
          >
            주소찾기
          </Box> */}
        </Box>
        <DaumPostcode
          onComplete={handleComplete}
          jsOptions={{ animation: true, hideMapBtn: true }}
        />
      </Dialog>

      <TextField
        fullWidth
        autoComplete="off"
        name="addr1"
        label="기본주소"
        size="small"
        sx={{
          width: '260px'
        }}
        onChange={(e) => {
          setAddr1(e.target.value);
          set1(e.target.value);
        }}
        onClick={()=>setOpen(true)}
        // sx={{ mt: 1 }}
        value={addr1}
      ></TextField>
      <TextField
        autoComplete="off"
        name="addr2"
        label="상세주소"
        size="small"
        sx={{ marginTop: '10px', width: "100%" }}
        onChange={(e) => {
          setAddr2(e.target.value);
          set2(e.target.value);
        }}
        value={addr2}
      ></TextField>
    </Box>
  );

}
export default RegisterFormAddr;
